var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHoverArrow = function SvgHoverArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    "aria-hidden": "true",
    className: "hover_arrow_svg__hover-arrow"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5h7",
    className: "hover_arrow_svg__hover-arrow__linePath"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1 1 4 4-4 4",
    className: "hover_arrow_svg__hover-arrow__tipPath"
  }))));
};
export default SvgHoverArrow;